let routerInstance = null;
export default async ({ router }) => {
    routerInstance = router;
};
export { routerInstance };
